import React from 'react'
import EditPageWorker from './edit'
import { Link, withRouter } from 'react-router-dom'
import PageForm from '../components/form/form.component'
import FormHelper from '../../../../utils/FormHelper'
import './edit.styles.scss'
import Dialog from '../../../../components/dialog/dialog.component'
import Loading from '../../../../components/loading/loading.component'

class EditPage extends React.Component {

    constructor(props) {
        super(props)
        this.editPageWorker = EditPageWorker(this)
        this.state = this.editPageWorker.getDefaultState()
    }

    componentDidMount(){
        this.editPageWorker.loadPage()
    }

    onSubmit = (e) => {
        e.preventDefault()
        this.editPageWorker.isValid() && this.editPageWorker.updatePage()
    }

    onCancel = () => this.props.history.push('/content/pages')

    render() {
        return (
            <div id="editPage" className="edit-page">
                {
                    this.state.loadingPage && <Dialog><Loading /></Dialog>
                }
                <div className="card">
                    <Link className="btn" to="/content/pages">Pages</Link>
                    <div className="header">
                        <h4>Edit Page</h4>
                    </div>
                    <div className={"flag " + this.state.flag.type}>
                        {this.state.flag.text}
                    </div>
                    <PageForm {...this.state} action="Save Page" onChange={FormHelper(this).onChange} onSubmit={this.onSubmit} onCancel={this.onCancel}/>
                </div>
            </div>
        )
    }
}

export default withRouter(EditPage)